import ApiService from "@/core/services/api.service";
const state = {
  users: [],
  instances: [],
  sessions: [],
  deadlines: [],
  myUser: {},
  myTeam: {},
  myInstances: [],
  myTeamInstances: [],
  projects: [],
  teams: [],
  mySessions: [],
  paths: [],
  tags: [],
  levels: [],
  outcomes: [],
  profiles: [],
  roles: [],
  forums: [],
  tutorials: [],
  challenges: [],
  loading: true,
};

const getters = {
  getUsers(state) {
    return state.users;
  },
  getRoles(state) {
    return state.roles;
  },
  getDeadlines(state) {
    return state.deadlines;
  },
  getInstances(state) {
    return state.instances;
  },
  getSessions(state) {
    return state.sessions;
  },
  getMyUser(state) {
    return state.myUser;
  },
  getMyTeam(state) {
    return state.myTeam;
  },
  getMyInstances(state) {
    return state.myInstances;
  },
  getMyTeamInstances(state) {
    return state.myTeamInstances;
  },
  getMySessions(state) {
    return state.mySessions;
  },
  getTeams(state) {
    return state.teams;
  },
  getProjects(state) {
    return state.projects;
  },
  getPaths(state) {
    return state.paths;
  },
  getTags(state) {
    return state.tags;
  },
  getLevels(state) {
    return state.levels;
  },
  getOutcomes(state) {
    return state.outcomes;
  },
  getProfiles(state) {
    return state.profiles;
  },
  getForums(state) {
    return state.forums;
  },
  getTutorials(state) {
    return state.tutorials;
  },
  getChallenges(state) {
    return state.challenges;
  },
};

const actions = {
  fetchAllBackend({ dispatch, commit }) {
    commit("setLoading", true);

    let users = dispatch("fetchUsers");
    let instances = dispatch("fetchInstances");
    let sessions = dispatch("fetchSessions");
    let projects = dispatch("fetchProjects");
    let deadlines = dispatch("fetchDeadlines");
    let paths = dispatch("fetchPaths");
    let teams = dispatch("fetchTeams");
    let levels = dispatch("fetchLevels");
    let tags = dispatch("fetchTags");
    let outcomes = dispatch("fetchOutcomes");
    let profiles = dispatch("fetchProfiles");
    let roles = dispatch("fetchRoles");
    let forums = dispatch("fetchForums");
    let me = dispatch("fetchMyUser");
    let challenges = dispatch("fetchChallenges");

    return Promise.all([
      users,
      me,
      roles,
      instances,
      sessions,
      deadlines,
      projects,
      teams,
      paths,
      levels,
      tags,
      outcomes,
      profiles,
      challenges,
      forums,
    ]).then(() => {
      // Both done
      console.log("Fetch All loaded Backend!", state.loading);

      commit("setLoading", false);
    });
  },
  fetchAllPosts({ dispatch, commit }) {
    commit("setLoading", true);

    let projects = dispatch("fetchProjects");
    let paths = dispatch("fetchPaths");
    let teams = dispatch("fetchTeams");
    let myUser = dispatch("fetchMyUser");
    let deadlines = dispatch("fetchDeadlines");
    //let myTeamInstances = dispatch("fetchMyTeamInstances");
    let myTeam = dispatch("fetchMyTeam");
    let myInstances = dispatch("fetchMyInstances");
    let mySessions = dispatch("fetchMySessions");
    let levels = dispatch("fetchLevels");
    let tags = dispatch("fetchTags");
    let outcomes = dispatch("fetchOutcomes");
    let profiles = dispatch("fetchProfiles");
    let forums = dispatch("fetchForums");
    let tutorials = dispatch("fetchTutorials");
    let users = dispatch("fetchUsers");
    let roles = dispatch("fetchRoles");
    let challenges = dispatch("fetchChallenges");

    return Promise.all([
      myUser,
      myTeam,
      deadlines,
      //myTeamInstances,
      projects,
      teams,
      paths,
      levels,
      tags,
      outcomes,
      profiles,
      myInstances,
      mySessions,
      users,
      roles,
      forums,
      tutorials,
      challenges,
    ]).finally(() => {
      // Both done

      console.log("Fetch All loaded FrontEnd!");
      commit("setLoading", false);
    });
  },
  fetchUsers({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Users");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("users")
        .then((res) => {
          commit("setUsers", res.data);
          resolve(state.users);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchRoles({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Roles");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("roles")
        .then((res) => {
          commit("setRoles", res.data);
          resolve(state.roles);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchInstances({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Instances");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("instances")
        .then((res) => {
          commit("setInstances", res.data);
          resolve(state.instances);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchSessions({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Sessions");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("sessions")
        .then((res) => {
          commit("setSessions", res.data);
          resolve(state.sessions);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchMyUser({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch My User");
    // console.log(rootGetters.currentUser);
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("users", "me")
        .then((res) => {
          commit("setMyUser", res.data);
          //console.log("My User", res.data);
          resolve(state.myUser);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchMyTeam({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch MyTeam");
    //console.log(rootGetters.currentUser);
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("teams", "me?fields=users,users-instances")
        .then((res) => {
          //console.log("My team on Fetch", res);
          commit("setMyTeam", res.data);
          resolve(state.myTeam);
        })
        .catch((err) => {
          console.log("error OnnFetch myteam", err);
        });
    });
  },

  fetchMyInstances({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch My Instances");
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("users", "me/instances")
        .then((res) => {
          commit("setMyInstances", res.data);
          resolve(state.myInstances);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchMySessions({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch My Sessions");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("users", "me/sessions")
        .then((res) => {
          commit("setMySessions", res.data);
          resolve(state.mySessions);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchProjects({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Projects");
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("projects").then((res) => {
        commit("setProjects", res.data);
        resolve(state.projects);
      });
    });
  },
  fetchPaths({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Paths");
    return new Promise((resolve) => {
      ApiService.get("paths").then((res) => {
        //console.log("📦 🙋🏾‍ Fetch Paths", res.data);
        commit("setPaths", res.data);
        resolve(state.paths);
      });
    });
  },
  fetchDeadlines({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Deadlines");
    return new Promise((resolve) => {
      ApiService.get("deadlines").then((res) => {
        //console.log("📦 🙋🏾‍ Fetch Paths", res.data);
        commit("setDeadlines", res.data);
        resolve(state.deadlines);
      });
    });
  },
  fetchTags({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Tags");
    return new Promise((resolve) => {
      ApiService.get("tags").then((res) => {
        commit("setTags", res.data);
        resolve(state.tags);
      });
    });
  },
  fetchLevels({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Levels");
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("levels").then((res) => {
        commit("setLevels", res.data);
        resolve(state.levels);
      });
    });
  },
  fetchOutcomes({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Outcomes");
    return new Promise((resolve) => {
      ApiService.get("outcomes").then((res) => {
        commit("setOutcomes", res.data);
        resolve(state.outcomes);
      });
    });
  },
  fetchProfiles({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Profiles");
    return new Promise((resolve) => {
      ApiService.get("profiles").then((res) => {
        commit("setProfiles", res.data);
        resolve(state.profiles);
      });
    });
  },
  fetchTeams({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch Teams");
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("teams", "?fields=users-points").then((res) => {
        commit("setTeams", res.data);
        resolve(state.paths);
      });
    });
  },
  fetchForums({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Forums");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("forum")
        .then((res) => {
          commit("setForums", res.data);
          resolve(state.forums);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchTutorials({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Forums");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("tutorials")
        .then((res) => {
          commit("setTutorials", res.data);
          resolve(state.tutorials);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  fetchChallenges({ state, commit }) {
    console.log("📦 🙋🏾‍ Fetch All Challenges");

    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get("challenges")
        .then((res) => {
          commit("setChallenges", res.data);
          resolve(state.challenges);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
};

const mutations = {
  setUsers(state, users) {
    state.users = users;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setInstances(state, instances) {
    state.instances = instances;
  },
  setDeadlines(state, dl) {
    state.deadlines = dl;
  },
  setSessions(state, sessions) {
    state.sessions = sessions;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setMyUser(state, user) {
    state.myUser = user;
  },
  setMyTeam(state, team) {
    state.myTeam = team;
  },
  setMyInstances(state, instances) {
    state.myInstances = instances;
  },
  setMySessions(state, sessions) {
    state.mySessions = sessions;
  },
  setTeams(state, teams) {
    state.teams = teams;
  },
  setProjects(state, projects) {
    state.projects = projects;
  },
  setPaths(state, paths) {
    state.paths = paths;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setLevels(state, levels) {
    state.levels = levels;
  },
  setOutcomes(state, outcomes) {
    state.outcomes = outcomes;
  },
  setProfiles(state, profiles) {
    state.profiles = profiles;
  },
  setForums(state, forums) {
    state.forums = forums;
  },
  setTutorials(state, tutorials) {
    state.tutorials = tutorials;
  },
  setChallenges(state, challenges) {
    state.challenges = challenges;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
